/*
  女性向けの LP 群 (体験、体験と相談の完了、ストーリー、30 日、実プロダクト開発演習) を、LINE のリッチメニューと同じ色と地に着せ替える CSS (2026-10-20)。
  文言、並び、写真、字の大きさ、レイアウトは変えない。変えるのは色、地、線、札の塗り、ボタンの色だけ。
  寄せる先は無料カウンセリング (pages/liff/counseling-line-tone.ts) とトップ (pages/index/sec-women-line.ts) と同じ値。
  根の印 lp-ln の下に閉じる。印は lp-w と一緒に付くので、lp-w の変数 (--w-*) を同じ強さで後から上書きする。
  pay の頁、v1、書類、下層の頁は印が無いので変わらない。
  緑 #05B45B の地の字は #141414。小さな字に #05B45B は使わず、字には #037F40。LINE のボタンは #06C755 のまま
*/
export const LP_LINE_CLASS = "lp-ln";

const S = ".lp-w.lp-ln";
export const INK = "#141414";
export const GREEN = "#05B45B";
export const GREEN_INK = "#037F40";
export const YELLOW = "#FFE566";
export const LIME = "#D9F99D";
const DOTS = "radial-gradient(circle,rgba(5,180,91,.28) 1.5px,transparent 1.9px) 0 0/18px 18px";
const WASH = "linear-gradient(160deg,#F2FCE8 0%,#DDF6E6 55%,#CDEFFA 100%)";
const SHOW = `${DOTS},${WASH}`;
const SOFT = "#F7FCF4";
const HAIR = "#D9D9D0";

/** lp-w が持つ --w-* の値を、緑の組に差し替える。ページごとの別名 (--cs-*、--tl-*、--st-* など) は lp-w の側で var(--w-*) から作られるので、ここで変えた値がそのまま流れる */
export const LP_LINE_VARS = `
${S}{
  --w-bg:#fff;--w-blush:${SOFT};--w-blush-2:#F2F9EE;--w-blush-3:#E3F3E8;
  --w-ink:${INK};--w-head:${INK};--w-sub:#3D3D3D;--w-note:#4A4A4A;
  --w-rose:${GREEN};--w-rose-ink:${GREEN_INK};--w-rose-soft:#9AD9B5;--w-mark:${YELLOW};
  --w-cta:${LIME};--w-cta-edge:${INK};--w-cta-hover:#CBF37F;--w-cta-press:#BDE96F;--w-cta-ink:${GREEN_INK};
  --w-navy:${INK};--w-navy-2:${INK};--w-teal:${GREEN};--w-aqua:#CDEFFA;
  --w-ground-alt:${SOFT};--w-ground-line:#DDEBDD;
  --w-grad-pink:#F2FCE8;--w-grad-lilac:#DDF6E6;--w-grad-sky:#CDEFFA;
  --w-show-grad:${SHOW};
  --w-end-wash:${WASH};
  --w-show-grad-v:${WASH};
  --w-rose-deep:${GREEN_INK};--w-sub-deep:#2E2E2E;--w-note-deep:#3D3D3D;
  --w-band-dim:#3D3D3D;--w-band-rule:rgba(20,20,20,.2);--w-band-edge:#F2FCE8;
  --w-rule:${HAIR};--w-shadow:none;
  --w-navy-grad:linear-gradient(${INK},${INK});
  --w-r:16px;--w-r-s:14px;
  --color-shegate-accent:${GREEN};
  --focus-ring:${GREEN_INK};
  letter-spacing:.03em}
`;

/** 形と色の共通部分。ボタンは黄緑に黒の 3px の縁の丸い札、緑の地の字は黒、カードは影なし */
export const LP_LINE_COMMON = `
${S} .lp-cta{background:${LIME}!important;color:${INK}!important;border:3px solid ${INK};border-radius:999px!important;box-shadow:none!important}
${S} .lp-cta :is(svg,span,b){color:${INK}}
${S} .lp-cta:hover{background:#CBF37F!important}
${S} .lp-cta:active{background:#BDE96F!important;transform:translateY(2px);box-shadow:none!important}
${S} .lp-cta:focus-visible{outline:3px solid ${GREEN_INK};outline-offset:3px}
${S} .lp-cta-badge{border-color:${INK}!important}
${S} .lp-cta-badge>*{color:${INK}!important}
${S} .shadow-lg,${S} .shadow-sm,${S} .shadow-md{box-shadow:none}
`;

/** 予約の LP (体験、完了) 用。FORM_LP_WOMEN_CSS の後ろに足す */
export const FORM_LINE_CSS = `${LP_LINE_VARS}${LP_LINE_COMMON}
${S} .tl-hero{background:${SHOW}!important}
${S}.tl-done,${S}.cs-done{background:${SHOW}!important}
${S}.cs-done{background:${SHOW},#fff!important}
${S} :is(.cs-show,.tl-show){background:${SHOW}!important}
${S} :is(.cs-close,.tl-close){background:${WASH}!important}
${S} .cs-hero-veil{background:${WASH}!important}
${S} .cs-end .lp-navy-veil{background:${WASH}}
${S} .lp-navy-veil{background:${INK}}
/* 緑 #05B45B の地の字は黒、白地の小さな緑の字は濃い緑 */
${S} [style*="color:var(--color-shegate-accent)"]:not([style*="background"]){color:${GREEN_INK}!important}
${S} [style*="background-color:var(--color-shegate-accent)"] :is(.text-white,svg){color:${INK}!important}
${S} [data-counseling-form] :is(.text-white,svg.text-white,span[style*="writing-mode"]){color:${INK}!important}
${S} [data-counseling-form] .rounded-full.bg-white{color:${GREEN_INK}!important}
${S} [data-counseling-form] .bg-white\\/30{background:rgba(20,20,20,.3)}
${S} .bg-shegate-accent{color:${INK}!important}
${S} .bg-shegate-accent :is(.text-white,svg){color:${INK}!important}
`;
